export enum Role {
  'INTERNALADMIN' = 'INTERNALADMIN',
  'ADMIN' = 'ADMIN',
  'EDITOR' = 'EDITOR',
  'OBSERVER' = 'OBSERVER',
}
